'use client'

import { ActionIcon, Flex, Skeleton } from '@mantine/core'
import { RiArrowLeftSLine, RiMenu3Line } from '@remixicon/react'
import { Text } from '@repo/ui'
import Image, { StaticImageData } from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { FC, useMemo } from 'react'

import dynamic from 'next/dynamic'
import { hamburgerMenuStore } from './Store'

const ProfileButtonWrapper = dynamic(
  () => import('./components').then((mod) => mod.ProfileButtonWrapper),
  {
    ssr: false,
    loading: () => <Skeleton w={44} h={44} radius={22} />,
  },
)

interface HeaderProps {
  mainIcon: StaticImageData
  withBackButton?: boolean
}

export const Header: FC<HeaderProps> = ({ mainIcon, withBackButton }) => {
  const pathName = usePathname()
  const { open } = hamburgerMenuStore()

  const prevPath = useMemo(() => {
    const segments = pathName.split('/')
    if (segments.length > 2) {
      return {
        url: `/${segments[1]}`,
        pathName: segments[1].replaceAll('-', ' '),
      }
    }
    return null
  }, [pathName])

  return (
    <header className={`w-[100%] h-[80px] flex flex-col px-2 py-4`}>
      <Flex justify='space-between' align='center' flex={1} px='sm'>
        <div className='ml-2'>
          <Flex
            hiddenFrom='sm'
            direction='column'
            justify='center'
            align='center'
            gap={7}
          >
            <Image src={mainIcon} alt='apartment icon' width={20} height={25} />
            <Text fz='xs' c='var(--mantine-color-Primary-6)'>
              Global
            </Text>
          </Flex>

          {prevPath && (
            <Flex visibleFrom='sm' align='center' gap='xs'>
              {withBackButton && (
                <Link
                  href={prevPath.url}
                  className='p-1 bg-[var(--mantine-color-Primary-6)] text-[var(--mantine-color-Primary-1)] rounded-full cursor-pointer'
                >
                  <RiArrowLeftSLine size={20} />
                </Link>
              )}
              <Text
                c='var(--mantine-color-Neutral-8)'
                className='first-letter:uppercase'
                fw={600}
                fz='sm'
              >
                {prevPath.pathName.toLocaleLowerCase()}
              </Text>
            </Flex>
          )}
        </div>

        <Flex gap='md' justify='center' align='center'>
          {/* <ActionIcon variant='transparent' size='sm'>
            <RiSearchLine size={16} />
          </ActionIcon> */}
          {/* <Tooltip label='Coming soon' withArrow position='bottom'>
            <RiNotificationLine size={16} />
          </Tooltip> */}
          {/* <Box visibleFrom='lg'>
            <HelpButton />
          </Box> */}

          {/* <Divider
            orientation='vertical'
            size='sm'
            mt='xs'
            mb='xs'
            visibleFrom='lg'
          /> */}
          <ProfileButtonWrapper />

          <ActionIcon
            variant='transparent'
            onClick={open}
            hiddenFrom='lg'
            size='md'
            bg='white'
            radius='md'
            c='var(--mantine-color-Primary-6)'
          >
            <RiMenu3Line size={16} />
          </ActionIcon>
        </Flex>
      </Flex>
    </header>
  )
}

export default Header
